import styled from 'styled-components'

export const Container = styled.div`
	form {
		display: grid;
		grid-template-columns: repeat(4, 1fr);
		padding-bottom: 24px;
		grid-template-areas:
			'crm nome espec espec'
			'situacao nasc sexo email'
			'cpf cpf_arquivo rg rg_arquivo'
			'action_footer action_footer action_footer action_footer';
	}

	@media(max-width: 1100px) {
		form {
			grid-template-columns: repeat(3, 1fr);
			grid-template-areas:
				'crm nome espec'
				'situacao nasc sexo'
				'email cpf rg'
				'cpf_arquivo rg_arquivo x'
				'action_footer action_footer action_footer';
		}
	}

	@media(max-width: 800px) {
		form {
			grid-template-columns: repeat(2, 1fr);
			grid-template-areas:
				'crm nome'
				'espec espec'
				'situacao nasc'
				'sexo email'
				'cpf rg'
				'cpf_arquivo rg_arquivo'
				'action_footer action_footer';
		}
	}

	@media(max-width: 600px) {
		form {
			display: flex;
			flex-direction: column;
		}
	}
`
